import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CandidatePersonalAction } from "../../../Redux/action/CandidatePersonalAction";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const CandidatePersonal = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({
        skypeId: "",
        whatsapp: "",
        country: "",
        state: "",
        city: "",
        hobbies: "",
        interest: "",
        gender: "Male"
    });

    const {
        skypeId,
        whatsapp,
        country,
        state,
        city,
        hobbies,
        interest,
        gender
    } = data;


    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.Profile.result);
    const user_personal = useSelector((state) => state?.CandidatePersonal?.data);

    let userData = userInfo;

    useEffect(() => {
        if (user_personal) {
            setData({ ...user_personal });
        }
        else if (userData) {
            setData({ ...userData });
        }
    }, [user_personal, dispatch, userData]);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const candidateId = userResult?.userid;;

    const handleSubmit = (e) => {
        e.preventDefault();
        let content = {
            candidateId,
            skypeId,
            whatsapp,
            country,
            state,
            city,
            hobbies,
            interest,
            gender
        };

        dispatch(CandidatePersonalAction(content));
    };
    const location = useLocation();
    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Update Your Personal Information.
                </BootstrapDialogTitle>
                <form onSubmit={handleSubmit}>
                    <Box
                        sx={{
                            width: 500,
                            maxWidth: '100%',
                        }}
                    >
                        <TextField fullWidth label="SkypeId" value={skypeId} name="skypeId" onChange={handleInputChange} />
                        <TextField fullWidth label="Whatsapp" onKeyPress={(e) => {
                            if (e.key !== 'Enter' && !/^[0-9]*$/.test(e.key)) {
                                e.preventDefault();
                            }
                        }} value={whatsapp} name="whatsapp" onChange={handleInputChange} inputProps={{
                            className: "text-fields-d",
                            inputMode: "numeric", // Only accept numeric input
                            pattern: "[0-9]*", // Only allow numbers
                            maxLength: 10 // Maximum length of 12 digits
                        }} />
                        <TextField fullWidth label="Country" name="country" value={country} onChange={handleInputChange} />
                        <TextField fullWidth label="State" name="state" value={state} onChange={handleInputChange} />
                        <TextField fullWidth label="City" name="city" value={city} onChange={handleInputChange} />
                        <TextField fullWidth label="Hobbies" name="hobbies" value={hobbies} onChange={handleInputChange} />
                        <TextField fullWidth label="Interest" name="interest" value={interest} onChange={handleInputChange} />
                        <div style={{ marginLeft: "15px" }}>
                            <select id="Gender" value={gender} onChange={handleInputChange} defaultValue="" name="gender" style={{padding: '4px'}}>
                                <option selected disabled value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                    </Box>
                    <DialogActions>
                        <Button autoFocus type="submit" onClick={handleClose}>
                            Save changes
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>
            <div className="">
                <div className='edit-button'>
                    <div className='overview tag_over'>
                        <span style={{ fontWeight: "bold" }}></span>
                        {location.state === null ? <><span onClick={handleClickOpen}><MdEdit /></span></> : console.log("data")}
                    </div>
                </div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>Skype Id</h5></div>
                        <div className="">
                            {skypeId ? <p className="">{skypeId}</p> : <p className="Warning_data">Please Fill Your skypeId</p>}
                        </div>
                    </div>
                </div>
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>Whatsapp</h5></div>
                        <div className="">
                            {whatsapp ? <p className="">{whatsapp}</p> : <p className="Warning_data">Please Fill Your Whatsapp Number</p>}
                        </div>
                    </div>
                </div>
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>country</h5></div>
                        <div className="">
                            {country ? <p className="">{country}</p> : <p className="Warning_data">Please Fill Your Country</p>}
                        </div>
                    </div>
                </div>
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>State</h5></div>
                        <div className="">
                            {state ? <p className="">{state}</p> : <p className="Warning_data">Please Fill Your State</p>}
                        </div>
                    </div>
                </div>
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>City</h5></div>
                        <div className="">
                            {city ? <p className="">{city}</p> : <p className="Warning_data">Please Fill Your City</p>}
                        </div>
                    </div>
                </div>
                {/* <div className='personal_hr'> <hr /></div> */}
                {/* <div className="contact_info-body">
          <div className="personal_info">
            <div className='personal_detail'>
              <h5>Pin-Code</h5></div>
            <div className="">
              {userInfo.pincode !== null && userInfo.pincode !== "" ? <p className="">{userInfo.pincode}</p> : <p className="Warning_data">Please Fill Your pincode</p>}
            </div>
          </div>
        </div> */}
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>Hobby</h5></div>
                        <div className="">
                            {hobbies ? <p className="">{hobbies}</p> : <p className="Warning_data">Please Fill Your Hobbies</p>}
                        </div>
                    </div>
                </div>
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>Interest</h5></div>
                        <div className="">
                            {interest ? <p className="">{interest}</p> : <p className="Warning_data">Please Fill Your Interest</p>}
                        </div>
                    </div>
                </div>
                <div className='personal_hr'> <hr /></div>
                <div className="contact_info-body">
                    <div className="personal_info">
                        <div className='personal_detail'><h5>Gender</h5></div>
                        <div className="">
                            {gender ? <p className="">{gender}</p> : <p className="Warning_data">Please Fill Your gender</p>}
                        </div>
                    </div>
                </div>
            </div></>
    )
}

export default CandidatePersonal